import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pefin',
  templateUrl: './pefin.component.html',
  styleUrls: ['./pefin.component.css', './../fdnet.component.css']
})
export class PefinComponent implements OnInit {

  @Input() dados: any;
  public naoSolicitou: Boolean = false;
  public naoEncontrouRegistros: Boolean = false;

  constructor() { }

  ngOnInit() {
    if (this.dados.pefin.registro.length === 0) {
      this.naoEncontrouRegistros = true;
    }
  }

}
